import { STALE_TIME_RESOURCES } from "@impero-com/common/utils/query_client";

import { useGetUsersUserIdSuspense } from "api/generated/users/users";

export const USER_WITH_DETAILS_QUERY_KEY = "user-with-details";
export function useUserWithDetailsQuery(userId: number) {
    return useGetUsersUserIdSuspense(userId, {
        query: {
            queryKey: [USER_WITH_DETAILS_QUERY_KEY, userId],
            select: (response) => response.data,
            refetchOnMount: true,
            refetchOnWindowFocus: true,
            staleTime: STALE_TIME_RESOURCES,
        },
    });
}
